import React, { useEffect } from 'react';
import styles from './CreditSummaryBar.module.scss';
import { NEW_TO_CREDIT_THRESHOLD } from '../CreditBureauConstants';
import { COMBINED_REPORT } from '../../../CreditBureau';

interface CreditSummaryBarProps {
    minScore;
    maxScore;
    selectedReport?;
}

const CreditSummaryBar: React.FC<CreditSummaryBarProps> = ({ minScore, maxScore, selectedReport }) => {
    const [width, setWidth] = React.useState(0);
    const isNewToCredit = () => {
        const primaryScore = maxScore || minScore;
        return typeof primaryScore == 'number' && primaryScore < NEW_TO_CREDIT_THRESHOLD;
    };

    const shouldShowMinScore = () => {
        // In combined reports, don't show minScore if it's <= 100
        if (selectedReport === COMBINED_REPORT && minScore && minScore <= 100) {
            return false;
        }
        return true;
    };
    useEffect(() => {
        if (maxScore) {
            setWidth((maxScore / 900) * 100);
        } else if (shouldShowMinScore() && minScore) {
            setWidth((minScore / 900) * 100);
        } else {
            setWidth(0);
        }
    }, [minScore, maxScore, selectedReport]);

    return (
        <div className={styles.BarContainer}>
            {isNewToCredit() ? (
                <div className={styles.NewToCreditContainer}>
                    <span className={styles.NewToCreditText}>Consumer is new to Credit</span>
                </div>
            ) : (
                <>
                    <div className={styles.Value}>
                        <span className={styles.Black}>
                            {shouldShowMinScore() && minScore ? minScore : ''}
                            {shouldShowMinScore() && minScore && maxScore ? `-${maxScore}` : maxScore ? maxScore : ''}
                        </span>
                        /900
                    </div>

                    <div className={styles.BarParent}>
                        <div className={styles.BarChild} style={{ width: `${width}%` }}></div>
                    </div>
                </>
            )}
        </div>
    );
};

export default CreditSummaryBar;
